module.exports = __webpack_public_path__ + "img/web-default.2bbe8522.png";